import { render, staticRenderFns } from "./TerapieComplicanzeEdit.vue?vue&type=template&id=3b5fe9a4&scoped=true"
import script from "./TerapieComplicanzeEdit.vue?vue&type=script&lang=js"
export * from "./TerapieComplicanzeEdit.vue?vue&type=script&lang=js"
import style0 from "./TerapieComplicanzeEdit.vue?vue&type=style&index=0&id=3b5fe9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5fe9a4",
  null
  
)

export default component.exports